import dayjs from 'dayjs'

export const isTimestampExpired = timestamp => {
  const timestampNumber = Number(timestamp)

  if (Number.isNaN(timestampNumber) || !Number.isFinite(timestampNumber)) {
    return true
  }

  return Number(dayjs()) > Number(timestamp)
}

export const createExpirationTimestamp = () => {
  return Number(dayjs().add(30, 'minute'))
}
